import { createSlice } from "@reduxjs/toolkit";
import {getAdminAgentList, getAgentList, getSingleAgent} from "../../services/clientlistingServices";
import {getAdminSingleAgent} from "../../services";

const clientListSlice = createSlice({
    name: "agent",
    initialState: {
        error: false,
        loading: false,
        records: [],
        singleList: {},
        total: 0,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAgentList.pending, (state) => {
                state.error = false;
                state.records = [];
            })
            .addCase(getAgentList.fulfilled, (state, action) => {
                state.records = action?.payload?.list ?? [];
                state.total = Number(action?.payload?.total) || 0;
            })
            .addCase(getAgentList.rejected, (state) => {
                state.records = [];
                state.error = true;
            })
            .addCase(getAdminAgentList.pending, (state) => {
                state.error = false;
                state.records = [];
            })
            .addCase(getAdminAgentList.fulfilled, (state, action) => {
                state.records = action?.payload?.records;
                state.total = action?.payload?.total ?? 0;
            })
            .addCase(getAdminAgentList.rejected, (state) => {
                state.records = [];
                state.error = true;
            })
            .addCase(getSingleAgent.pending, (state) => {
                state.error = false;
                state.loading = true;
            })
            .addCase(getSingleAgent.fulfilled, (state, action) => {
                state.singleList = action?.payload;
                state.loading = false;
                state.error = false;
            })
            .addCase(getSingleAgent.rejected, (state) => {
                state.singleList = {};
                state.error = true;
                state.loading = false;
            })
            .addCase(getAdminSingleAgent.pending, (state) => {
                state.error = false;
                state.loading = true;
            })
            .addCase(getAdminSingleAgent.fulfilled, (state, action) => {
                state.singleList = action?.payload;
                state.loading = false;
                state.error = false;
            })
            .addCase(getAdminSingleAgent.rejected, (state) => {
                state.singleList = {};
                state.error = true;
                state.loading = false;
            });
            

    },
});

export const { } = clientListSlice.actions;
export default clientListSlice.reducer;
